import React from 'react';
// Constants
import {
  CompanyName,
  CompanyTagLine,
  FULL_BUSINESS_URL,
  KeywordsPages,
  PER_MIN_AMOUNT,
} from '../../utils/constants/Constants';
import { CLIPS_PAGE_URL, HOME_PAGE_URL } from '../../utils/constants/Routes';
// Data
import {
  clipsPageAdditionalMeta,
  clipsPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ClipsPageMainContainer from '../../components/clips/ClipsPageMainContainer';
// Utils
import { buildBreadcrumbLd } from '../../utils/seo/breadcrumbs';
import FAQSchema from '../../utils/seo/FAQSchema';
import { clipsPageFaqItems } from '../../utils/data/faqSchemas';

function ClipsPage() {
  const breadcrumbLd = buildBreadcrumbLd({
    baseUrl: FULL_BUSINESS_URL,
    items: [
      { label: 'Home', href: HOME_PAGE_URL },
      { label: 'Clips', href: CLIPS_PAGE_URL },
    ],
  });

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Exclusive Clips'
        desc={`Unlock exclusive content from ${CompanyName}. Explore My private clips and indulge in elite muscle domination, fetish control, and premium submission experiences.`}
        keywords={KeywordsPages}
        additionalMeta={clipsPageAdditionalMeta}
        structuredData={[clipsPageStructuredData, breadcrumbLd]}
        canonicalPath={CLIPS_PAGE_URL}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full overflow-hidden font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='pt-24 px-8 lg:container lg:mx-auto lg:px-24'>
            <h1
              aria-label={`Exclusive clips by ${CompanyName}`}
              className='text-center font-titleFont text-6xl lg:text-6xl tracking-widest'
            >
              Exclusive Clips
            </h1>

            <div className='mx-auto grid justify-center'>
              <h2 className='text-xl xs:text-2xl mt-1 sm:text-3xl md:text-4xl lg:text-4xl lg:py-2 text-center'>
                {CompanyTagLine}
              </h2>
            </div>

            <div className='grid h-fit gap-y-4 pt-6'>
              <p className='text-center text-lg max-w-3xl mx-auto'>
                Here’s a taste of some of My most popular muscle domination
                clips. These previews give you just a glimpse into the
                mind-warping, body-worshipping world I create. I am a{' '}
                <strong>muscle Dominatrix</strong> who crafts intense, erotic
                content that blends power, seduction, humiliation, and control.
                <br />
                <br />
                Want more? I have <strong>150+ full clips</strong> waiting for
                you in My stores. Scroll, preview, and when you’re ready to
                surrender, click the links below to buy the complete
                experiences.
              </p>

              <p className='text-center text-base text-gray-300 max-w-3xl mx-auto'>
                Custom clips are available upon request. The rate is{' '}
                <strong>${PER_MIN_AMOUNT} per minute</strong> with a{' '}
                <strong>5-minute minimum</strong> per order.
              </p>
            </div>
          </header>

          {/* Main page content */}
          <ClipsPageMainContainer />
        </div>

        {/* FAQ JSON-LD */}
        <FAQSchema items={clipsPageFaqItems} />
      </div>
    </>
  );
}

export default ClipsPage;
